import { HttpEvent } from '@angular/common/http';
import { InjectionToken } from '@angular/core';
import { FileSessionEntity } from '@nk/data-entities-lib';
import { Observable } from 'rxjs';

export interface FileApiService {
  getFullFilePathsForFiles(
    filePathWithoutFileSession: string[],
    filePrefix?: string | undefined,
    bucketName?: string,
  ): Observable<string[]>;
  postFileSessionForFilePaths(filePaths: string[], appCustomerUuid: string): Observable<FileSessionEntity[]>;
  postFileWithFilePath(file: File, filepath: string, contentType: string): Observable<HttpEvent<unknown>>;
}

export const FILE_API_SERVICE_TOKEN = new InjectionToken<FileApiService>('FileApiService');
